/**
 * ActiveChallengesSection Component
 * Displays active challenges using the same MatchResultCard as history (pill shows Live/Active).
 */

import React, { useMemo } from 'react';
import { View } from 'react-native';
import type { PickHistoryEntry } from '../../../src/friends/types/friends.types';
import type { EquippedMap } from '../../avatars/LayeredAvatarLab/characterCustomizer.types';
import { MatchResultCard } from './MatchResultCard';
import { getActiveChallengesSectionStyles } from './ActiveChallengesSection.styles';

interface ActiveChallengesSectionProps {
  activeChallenges: PickHistoryEntry[];
  friendName: string;
  userAvatarId?: string | null;
  userAvatarConfig?: EquippedMap | null;
  friendAvatarId?: string | null;
  friendAvatarConfig?: EquippedMap | null;
  friendFallbackUrl?: string | null;
  /** Test ID for testing */
  testID?: string;
}

export const ActiveChallengesSection: React.FC<ActiveChallengesSectionProps> = ({
  activeChallenges,
  friendName,
  userAvatarId,
  userAvatarConfig,
  friendAvatarId,
  friendAvatarConfig,
  friendFallbackUrl,
  testID,
}) => {
  const styles = useMemo(() => getActiveChallengesSectionStyles(), []);

  if (activeChallenges.length === 0) {
    return null;
  }

  return (
    <View style={styles.activeChallengesContainer} testID={testID || 'active-challenges-section'}>
      <View style={styles.activeChallengesCardsContainer}>
        {activeChallenges.map((challenge) => (
          <MatchResultCard
            key={challenge.challengeId}
            data={challenge}
            friendName={friendName}
            userAvatarId={userAvatarId}
            userAvatarConfig={userAvatarConfig}
            friendAvatarId={friendAvatarId}
            friendAvatarConfig={friendAvatarConfig}
            friendFallbackUrl={friendFallbackUrl}
            testID={testID ? `${testID}-${challenge.challengeId}` : undefined}
          />
        ))}
      </View>
    </View>
  );
};

